import { light } from '@fortawesome/fontawesome-svg-core/import.macro';
import React, { useContext, useEffect, useState } from 'react';
import { Container, Row } from 'react-bootstrap';
import Modal from 'react-bootstrap/Modal';
import ModalBody from 'react-bootstrap/ModalBody';
import Button from '../../../../components/Button';
import DefaultCard from '../../../../components/DefaultCard';
import IconButton from '../../../../components/IconButton';
import Link from '../../../../components/Link';
import ModalHeader from '../../../../components/ModalHeader';
import { RadioGroup } from '../../../../components/Radio';
import SelectableCard from '../../../../components/SelectableCard';
import { EnrollmentStore } from '../../../../providers/enrollment';
import { getAllBaseLifeInsurances } from '../../../../services/enrollment';

export type customBaseLifeInsuranceModalProps = {
  showBaseLifeInsuranceModal: boolean;
  handleCloseBaseLifeInsuranceModal: () => void;
};

const BaseLifeInsuranceModal = ({
  showBaseLifeInsuranceModal,
  handleCloseBaseLifeInsuranceModal,
}: customBaseLifeInsuranceModalProps) => {
  const [showDetails, setShowDetails] = useState<boolean>(false);
  const [baseLifeInsuranceData, setBaseLifeInsuranceData] = React.useState<any>(
    {}
  );
  const [tellMeMore, setTellMeMore] = useState(false);
  const { activeLifeAndDisabilityInsurances, updateCost, updatePlanName } =
    useContext(EnrollmentStore);

  const [radioButtonValue, setRadioButtonValue] = React.useState<
    string | number
  >(9);

  useEffect(() => {
    const data = getAllBaseLifeInsurances();

    if (data) {
      setBaseLifeInsuranceData(data);
    }
  }, [baseLifeInsuranceData]);

  useEffect(() => {
    const currentBenefit = activeLifeAndDisabilityInsurances.find(
      (benefit: any) => benefit.type === 'base-life'
    );
    const index = baseLifeInsuranceData.plans?.findIndex(
      (plan: any) => plan.id === currentBenefit?.plan?.id
    );
    setRadioButtonValue(index);
  }, [activeLifeAndDisabilityInsurances, baseLifeInsuranceData]);

  const handleRadioButtonValue = (e: string | number) => {
    setRadioButtonValue(e);
  };

  const toggleDetails = () => {
    setShowDetails(!showDetails);
  };

  const toggleTellMeMore = () => {
    setTellMeMore((prev) => !prev);
  };

  return (
    <>
      {baseLifeInsuranceData ? (
        <Modal
          show={showBaseLifeInsuranceModal}
          onHide={handleCloseBaseLifeInsuranceModal}
          dialogClassName="modal-xl"
          className="custom-health-savings-modal"
        >
          <ModalHeader
            rightButton={
              <div onClick={toggleDetails} className={'icon-button-wrapper'}>
                <IconButton
                  variant="icon-default"
                  icon={light('circle-exclamation')}
                  extLabel="Benefit Info"
                />
              </div>
            }
            leftIcon={light('hospitals')}
            leftIconVariant="icon-default"
          >
            <h4 className="text-sm-20-lg-32">
              {baseLifeInsuranceData['generic']
                ? baseLifeInsuranceData['generic']['title']
                : ''}
            </h4>
          </ModalHeader>
          <ModalBody>
            <Row className={`expandable-wrapper ${showDetails ? 'open' : ''}`}>
              <div className="d-flex justify-content-center">
                <DefaultCard
                  closeButton={
                    <Link 
                      className='pt-0' 
                      isAlignAtEnd 
                      isWhiteIcon 
                      rightIcon={light('close')}
                      onClick={toggleDetails}
                    />                      
                  }
                  variant="blue-motif"
                  leftHeading={
                    baseLifeInsuranceData['generic']
                      ? baseLifeInsuranceData['generic']['info']['title']
                      : ''
                  }
                  leftSubheading={
                    <Container className={'px-0 d-flex flex-column'}>
                      {baseLifeInsuranceData['generic'] ? (
                        <>
                          <span>
                            {
                              baseLifeInsuranceData['generic']['info'][
                                'description'
                              ]
                            }
                          </span>
                          {tellMeMore && (
                            <span className={'mt-1'}>
                              {
                                baseLifeInsuranceData['generic']['info'][
                                  'additionalDescription'
                                ]
                              }
                            </span>
                          )}
                        </>
                      ) : (
                        ''
                      )}
                    </Container>
                  }
                  button={
                    <Button
                      onClick={toggleTellMeMore}
                      variant="primary-shadow"
                      size="sm"
                    >
                      {tellMeMore ? 'Tell me less' : 'Tell me more'}
                    </Button>
                  }
                  className={'mb-12'}
                />
              </div>
            </Row>
            <Container className="p-0">
              <Row className="mb-7 mb-lg-12">
                <h5 className="text-sm-14-lg-24">
                  What option would you like?
                </h5>
              </Row>
              <Row>
                <RadioGroup
                  name={'pricing-test1'}
                  value={radioButtonValue}
                  onChange={handleRadioButtonValue}
                >
                  <div>
                    {baseLifeInsuranceData['plans']
                      ? baseLifeInsuranceData['plans'].map(
                          (
                            plan: {
                              title: string;
                              cost: any;
                              coverage: number;
                            },
                            i: any
                          ) => (
                            <SelectableCard
                              title={plan.title}
                              prePaydPeriod={plan.cost}
                              radioButtonValue={i}
                              selected={radioButtonValue === i}
                              disabled={
                                i === baseLifeInsuranceData['plans'].length - 1
                              }
                              key={i}
                            />
                          )
                        )
                      : ''}
                  </div>
                </RadioGroup>
              </Row>
            </Container>
          </ModalBody>
          <Modal.Footer className="pt-7">
            <Button
              onMouseDown={handleCloseBaseLifeInsuranceModal}
              className="text-nowrap mt-7 mt-lg-0"
              variant="primary-outline"
            >
              Cancel
            </Button>
            <Button
              onMouseDown={() => {
                updateCost(
                  'base-life',
                  baseLifeInsuranceData.plans[radioButtonValue]
                );
                updatePlanName(
                  'base-life',
                  baseLifeInsuranceData.plans[radioButtonValue]
                );
                handleCloseBaseLifeInsuranceModal();
              }}
              className="text-nowrap"
              variant="primary"
            >
              Continue
            </Button>
          </Modal.Footer>
        </Modal>
      ) : (
        'NO DATA'
      )}
    </>
  );
};

export default BaseLifeInsuranceModal;
